import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import ContinueBtn from '../Shared/ContinueBtn/ContinueBtn';
import ChartBlock from '../Shared/ChartBlock/ChartBlock';
import Wrapper from '../../../hoc/Wrapper';
import './Overview.css';
import utility from "../../../../utility/utility";


class Overview extends Component {
    render() {
        const {
            main_html,
        } = this.props.pageData.content;

        const {
            vata,
            pitta,
            kapha,
            name,
            type
        } = this.props;

        let htmlContents = '';
        htmlContents = main_html.map((item, index) => {
            return <div className="content__item_wrapper" key={index} dangerouslySetInnerHTML={{__html: item}}/>
        });

        return (
            <Wrapper>
                <section className="overview__top">
                    <div className="overview__top-text">
                        <h1 className="title overview__top-title">{name}, the quiz results show that your dominant dosha
                            is <span className="title__body-type">{utility.toHyphenCase(type)}.</span></h1>
                    </div>

                    <div className="overview__chart-wrapper">
                        <ChartBlock
                            vata={vata}
                            pitta={pitta}
                            kapha={kapha}
                        />
                    </div>
                </section>

                <div className="report_html__content">
                    {htmlContents}
                </div>

                <ContinueBtn link="/report/foods-and-diet" txt="Foods and Diet"/>
            </Wrapper>
        );
    }
}

export default Overview;



// WEBPACK FOOTER //
// ./src/components/Report/ReportContent/Overview/Overview.js